module.exports = __webpack_public_path__ + "img/attach-2.7fab7611.svg";